import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { IAppState, QAProps } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { isFocused, MENU_EXPAND_BUTTON_FOCUSABLE_ID, MenuNavigationSectionType } from "../../navigation";
import { MenuPanelItemId } from "../../panelItems";
import { getExpandButtonIconCode, getExpandButtonTitle } from "../../selectors";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createMenuItemMouseActivationHandler } from "../../utils";
import { MenuPanelItemComponent, MenuPanelItemComponentProps } from "../MenuPanelItemComponent";

export type MenuExpandButtonProps = QAProps;

type StateProps = Pick<MenuPanelItemComponentProps, "title" | "iconCode" | "isFocused">;

const mapStateToProps: MapStateToProps<StateProps, MenuExpandButtonProps, IAppState> = (state) => ({
    title: getExpandButtonTitle(state),
    iconCode: getExpandButtonIconCode(state),
    isFocused: isFocused(state, MENU_EXPAND_BUTTON_FOCUSABLE_ID),
});

type DispatchProps = {
    buttonActivated: typeof createMenuItemActivatedAction;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, MenuExpandButtonProps> = {
    buttonActivated: createMenuItemActivatedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, MenuExpandButtonProps, MenuPanelItemComponentProps> = (
    stateProps,
    { buttonActivated },
    { qa },
) => ({
    ...stateProps,
    onClick: createMenuItemMouseActivationHandler(MenuPanelItemId.expandButton, MenuItemActivatedType.expandButton, MenuNavigationSectionType.static, buttonActivated),
    onKeyUp: createMenuItemKeyActivationHandler(MenuPanelItemId.expandButton, MenuItemActivatedType.expandButton, MenuNavigationSectionType.static, buttonActivated),
    isExpandArrowVisible: false,
    qa,
});

export const MenuExpandButton = connect(mapStateToProps, mapDispatchToProps, mergeProps)(MenuPanelItemComponent);
